/**
 * loom-a11y.js
 * Auto-assigns aria-label to empty links based on their href handle.
 */
(function() {
  'use strict';

  function labelEmptyLinks() {
    var links = document.querySelectorAll('a[href]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href');

      if (!href || href === '#' || href === '') continue;
      if (link.getAttribute('aria-label') || link.getAttribute('aria-labelledby')) continue;
      if (link.textContent.trim() !== '') continue;

      var imgs = link.querySelectorAll('img[alt]');
      var hasAltImg = false;
      for (var j = 0; j < imgs.length; j++) {
        if (imgs[j].getAttribute('alt').trim() !== '') {
          hasAltImg = true;
          break;
        }
      }
      if (hasAltImg) continue;

      var segments = href.replace(/\/+$/, '').split('/');
      var handle = segments[segments.length - 1] || '';

      if (!handle || handle === '#') continue;

      handle = handle.split('?')[0].split('#')[0];
      if (!handle) continue;

      var label = handle.replace(/-/g, ' ');
      label = label.charAt(0).toUpperCase() + label.slice(1);

      link.setAttribute('aria-label', 'View ' + label);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelEmptyLinks);
  } else {
    labelEmptyLinks();
  }

  if (typeof InstantClick !== 'undefined') {
    InstantClick.on('change', labelEmptyLinks);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      if (typeof InstantClick !== 'undefined') {
        InstantClick.on('change', labelEmptyLinks);
      }
    });
  }

  document.addEventListener('shopify:section:load', labelEmptyLinks);
})();
